import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/Services/api.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

@Component({
  selector: 'g10-openbooking-status',
  templateUrl: './booking-count-component.component.html',
  // styleUrls: ['./booking-count-component.component.css']
})
export class OpenBookingStatusComponent implements OnInit {
  public formSubmitted:boolean= false;
  public isEdit:boolean= false;
  public enableDate :boolean = true;
  public errorObject:any={};
  public fieldvalue:any;
  public showDate:any;
  public setID :any;
  public isReadonly = true;
  public settingsID: any;
  matFormSize = '13px';
  maxDate = new Date().toISOString().slice(0, 10);
  public statusControl:any = [ 
    { status:'Open' },
    { status:'Close' } 
  ]
public limitMonths:any=[];
  public allMonths:any = [
     {
      month: "January",
      count:1
    }, {
      month: "February", count:2
    },
    {
      month: "March", count:3
    },
    {
      month: "April", count:4
    },
    {
      month: "May", count:5
    },
    {
      month: "June", count:6
    },
    {
      month: "July", count:7
    },
    {
      month: "August", count:8
    },
    {
      month: "September", count:9
    },
    {
      month: "October", count:10
    },
    {
      month: "November", count:11
    },
    {
      month: "December", count:12
    }
  ]

  public daysType :any = [
  //   { 
  //   type : "Day"
  //  }, 
   { 
    type : "Month" 
  }]

  public formObject: any = {
    bookingStatus: {
      status: '',
      day : ''
    },
    availBookingDays:{
      daysPeriod:'',
      limit:''
    }
  }

  constructor( private api: ApiService , private swal: SweetAlert) { }
  
  ngOnInit(): void {
        this.getopenBookingList();
        this.monthList()
  }
 monthList(){
  this.limitMonths=[]
  let currentMonth=new Date().getMonth();
  if(currentMonth>=6){
    let remainder=(currentMonth+7)%12
    this.limitMonths=[...this.allMonths.slice(currentMonth+1,12),...this.allMonths.slice(0,remainder)]
  }
  else{
    this.limitMonths=this.allMonths.slice(currentMonth+1,currentMonth+7)

  }
 }
  getopenBookingList() {
    this.api.transportManagerGlbOpenBookingStatusList({}).then((res: any) => {
      if (res && res.status == 'success') {
        if(res.data && res.data[0]) {
          this.isEdit = true;
         this.patchValue(res.data[0])
      }
      }
    }).catch((err) => {
      console.log('error', err);
    })
  }

  patchValue(obj) {
    this.formObject.bookingStatus.status =  obj['bookingStatus']['status'];
    this.showDate = obj['bookingStatus']['day'];
    if(obj['bookingStatus']['status'] == 'close') {
      this.enableDate = false;
    }
    this.formObject.bookingStatus.day = (obj['bookingStatus']['day'] == null) ? null: new Date(obj['bookingStatus']['day']);
    this.formObject.availBookingDays.daysPeriod = obj.availBookingDays.daysPeriod
    this.formObject.availBookingDays.limit = obj.availBookingDays.limit
    this.settingsID = obj['settingsID'];
    
    if(this.formObject.bookingStatus.status == 'close' && this.formObject.bookingStatus.day == null) {
      this.formObject.bookingStatus.day = null;
    }
  }

  validation()
  {
    let isValid = true;
    this.errorObject = {};
    if (this.formObject.bookingStatus.status == '') {
      this.errorObject['status'] = 'Booking Status is required.'
      isValid = false;
    }
    if (this.formObject.availBookingDays.daysPeriod == '') {
      this.errorObject['daysPeriod'] = 'Daysperiod is required.'
      isValid = false;
    }
    if (this.formObject.availBookingDays.limit == '') {
      this.errorObject['limit'] = 'Limit is required.'
      isValid = false;
    }
    return isValid;
  }
 
  onSubmit() {
    this.formSubmitted = true;
    let isValid = this.validation();
      if (isValid) {
        let obj = {
          "bookingStatus": {
          status:this.formObject.bookingStatus.status,
          day: (this.formObject.bookingStatus.day == null) ? null : 
          new Date(new Date(this.showDate).setHours(23,59,59,59)).getTime()
          },
          "availBookingDays": {
            daysPeriod:this.formObject.availBookingDays.daysPeriod,
            limit:this.formObject.availBookingDays.limit
          }
        }
        let apiMethod = "transportManagerGblSetOpenBookingStatusCreate";
        if (this.isEdit) {
          apiMethod = "transportManagerGblOpenBookingStatusUpdate";
          obj['settingsID'] = this.settingsID;
        }
        this.api[apiMethod](obj).then((res) => {
          if (res.status == 'success') {
            this.getopenBookingList();
            this.swal.swalFunction(res.status, res.status, res.message, 2000);
          }
          if (res.status == 'failure') {
            this.swal.swalFunction('error', res.status, res.message, 3000);
          }
        }).catch((err) => {
          console.log('error', err);
        })
      }
    }

    dateChange(val) {
        this.showDate= val.value
    }

    onStatusChange(data) {
        this.fieldvalue=data.value;
        if(data.value == 'close') {
          this.enableDate = false;
          this.formObject.bookingStatus.day = null; 
          // if(this.formObject.bookingStatus.day == null) {
          //   this.formObject.bookingStatus.day = '';
          // }
          this.isReadonly = !this.isReadonly
        }
        else {
          this.enableDate = true;
        }
    }

    resetDate(){
      this.formObject.bookingStatus.day = null; 
    }
}